import { createContext, useContext } from "react";

export type PriceListGuideType = {
  page: PriceListGuidePages;
  setPage: (page: PriceListGuidePages) => void;
  onConfirm: () => void;
  selectedPriceListId?: number;
  setSelectedPriceListId: (id: number) => void;
};

export enum PriceListGuidePages {
  SCREEN_1,
  SCREEN_2,
  SCREEN_3,
  SCREEN_4,
  SCREEN_5,
}

export const PriceListGuideContext = createContext<
  PriceListGuideType | undefined
>(undefined);

export const usePriceListGuideContext = () => {
  const context = useContext(PriceListGuideContext);
  if (context === undefined) {
    throw new Error(
      "usePriceListGuideContext must be within PriceListGuideContextProvider",
    );
  }

  return context;
};
